export const services = [
  {
    title: 'AI資料作成サービス Narrative',
    mainTitle: 'NARRATIVE',
    // 9 文字あるので 72px のままだと 35% 幅のカラムで添え語・バッジと重なる。
    titleScale: 0.55,
    // 製品名は Narrative だけ（「NARRATIVE AI」と読めないよう添え語は出さない）
    workspaceText: '',
    gradient: 'linear-gradient(135deg, #2B4EE6 0%, #56B8A5 100%)',
    gradientColors: { from: '#2B4EE6', to: '#56B8A5' },
    description: 'Claude や ChatGPT などの AI との対話から、会社のデザインで統一された資料を作成・修正できる自社サービス。PDF・PowerPoint に書き出せ、版と直した人の経緯がチームに残ります。',
    subtitle: 'AI との対話から、チームに残る資料へ',
    badge: '提供中',
    // バッジをカラム右端固定でなくタイトル直後に置く。
    // absolute のままだとイタリック体の右上がバッジに食い込む。
    badgeInline: true,
    // 自社サービスへの外部リンク（被リンク用。nofollow は付けない）
    link: 'https://makenarrative.com/',
    linkLabel: 'makenarrative.com',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=300&fit=crop',
    mockup: 'mockup/mockup_pawapo.webp',
    tabIcon: '/tab_items/tab_item_pawapo.webp',
  },
  {
    title: 'Webアプリ制作',
    mainTitle: 'WEB',
    workspaceText: 'APPLICATION',
    gradient: 'linear-gradient(135deg, #06B6D4 0%, #14B8A6 100%)',
    gradientColors: { from: '#06B6D4', to: '#14B8A6' },
    description: 'ECマーケットプレイス、旅行予約ウェブアプリ、各種管理画面、業務効率化ツール、カスタムダッシュボードまで、過去の実績に基づいて確かな品質の製品をご提供します。',
    subtitle: 'Webアプリ制作',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=300&fit=crop',
    mockup: 'mockup/mockup_3.webp',
    tabIcon: '/tab_items/tab_item_3.webp',
  },
  {
    title: 'AIアプリ受託開発',
    mainTitle: 'AI',
    workspaceText: 'APPLICATION',
    gradient: 'linear-gradient(135deg, #FB7185 0%, #F9A8D4 100%)',
    gradientColors: { from: '#FB7185', to: '#F9A8D4' },
    description: '7年間の自社サービス開発で培った技術力と使いやすいUIUX設計力を活用して、AIアプリの受託開発を行います。',
    subtitle: 'AIアプリ受託開発',
    image: 'https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=400&h=300&fit=crop',
    mockup: 'mockup/mockup_4.webp',
    tabIcon: '/tab_items/tab_item_4.webp',
  },
];

export const slideVariants = {
  enter: (dir) => ({
    x: dir > 0 ? 1000 : -1000,
    opacity: 0,
  }),
  center: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 0.8,
      ease: [0.6, 0.01, 0.05, 0.95],
    },
  },
  exit: (dir) => ({
    x: dir > 0 ? -1000 : 1000,
    opacity: 0,
    transition: {
      duration: 0.8,
      ease: [0.6, 0.01, 0.05, 0.95],
    },
  }),
};
